import { useEffect, useRef } from 'react';

const RETURN_MARKERS = [
  'setup_intent_client_secret',
  'payment_intent_client_secret',
  'redirect_status',
];
const RETURN_PARAMS = [...RETURN_MARKERS, 'setup_intent', 'payment_intent'];

export const checkoutUrl = () => `${window.location.origin}${window.location.pathname}`;

export const isStripeReturn = (search) => {
  const params = new URLSearchParams(search);
  return RETURN_MARKERS.some((name) => params.has(name));
};

const withoutReturnParams = () => {
  const params = new URLSearchParams(window.location.search);
  RETURN_PARAMS.forEach((name) => params.delete(name));
  const query = params.toString();
  return `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`;
};

export function useStripeReturn(refresh) {
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current || !isStripeReturn(window.location.search)) {
      return;
    }
    handled.current = true;
    Promise.resolve(refresh()).finally(() =>
      window.history.replaceState(window.history.state, '', withoutReturnParams())
    );
  }, [refresh]);
}
